import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import MENU from "./step_menu.json";

const myConfiguration = reactive({ initialize: true });

export default function () {
  const store = useStore();
  const carJson = store.state;
  const menu_list = MENU.lists;
  const jsonAR = carJson.AR.lists;
  const jsonCA = carJson.CA.lists;        // 2025.06.05 11:00 復活
  const jsonLU = carJson.LU.lists;        // 2025.10.02 11:00 復活
//  const jsonME = carJson.ME.lists;      // 2023.07.28 削除
//  const jsonRS = carJson.RS.lists;      // 2025.12.26 11:00 削除
//  const jsonMEST = carJson.MEST.lists;  // 2023.07.28 削除
//  const jsonTW = carJson.TW.lists;      // 2024.10.23 削除
  const jsonKN = carJson.KN.lists;
  const car_list = [
    jsonLU[0],                            // 2025.10.02 11:00 復活 & 先頭
    jsonCA[0],                            // 2025.06.05 11:00 復活 & 先頭　　　　　
    jsonAR[0],
    jsonKN[0],                            // 2025.12.26 11:00 削除
//    jsonRS[0],
//    jsonTW[0],                          // 2023.07.28 削除
//    jsonME[0],                          // 2023.07.28 削除
//    jsonMEST[0],                        // 2023.07.28 削除
  ];

  const getMyParam = () => myConfiguration["param"];
  const getMyCheck = () => myConfiguration["check"];
  const getMySelect = () => __getMySelect();

  const getTitle = () => myConfiguration["title"];
  const getQueryKey = () => myConfiguration["active_menu"].query;
  const getMenuList = () => myConfiguration["menu_list"];
  const getMenuActive = () => myConfiguration["active_menu"];
  const getMenuActiveIndex = () => myConfiguration["active_menu_index"];

  const getDataCar = () => myConfiguration["carInfo"];
  const getBodyType = () => myConfiguration["bodyTypeInfo"];
  const getDataGreade = () => myConfiguration["gradeInfo"];
  const getDataEngine = () => myConfiguration["engineInfo"];
  const getDataColor = () => myConfiguration["colorInfo"];
  const getDataMakerOptions = () => {
    let list = []
    getListMakerOptions().forEach((item) => {
      item.list = myConfiguration[item.code + "Info"]
      list.push(item)
    });
    return list;
  }
  const getDataAccessories = () => {
    let list = []
    getListAccessories().forEach((item) => {
      item.list = myConfiguration[item.code + "Info"]
      list.push(item)
    });
    return list;
  }
  const getDataServices = () => {
    let list = []
    getListServices().forEach((item) => {
      item.list = myConfiguration[item.code + "Info"]
      list.push(item)
    });
    return list;
  }
  const getTotalPrice = () => __getTotalPrice();
  const getListCarLineup = () => car_list;
  const getListGrade = () => {
    // getDataEngine()
    const carInfo = getDataCar();
    return carInfo
      .grades.filter((list) => list.active === "true")
      .sort(function (a, b) {
        if (a.order > b.order) {
          return 1;
        } else {
          return -1;
        }
      });
  }
  const existsMakerOption  = () => {
    const grade = getDataGreade();
    return ("maker_options" in grade);
  }
  const getListColor = () =>
    getDataGreade()
      .colors.filter((list) => list.active === "true")
      .sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0
      });
  const getListMakerOptions = () =>{
    if (!existsMakerOption()) return [];
    return fncArrayGroupOption(
      getDataGreade()
        .maker_options.filter((list) => list.active === "true")
        .sort(function (a, b) {
          if (a.order > b.order) {
            return 1;
          } else {
            return -1;
          }
        })
    );
  }
  const getListAccessories = () =>
    fncArrayGroupOption(
      getDataGreade()
        .accessories.filter((list) => list.active === "true")
        .sort(function (a, b) {
          if (a.order > b.order) {
            return 1;
          } else {
            return -1;
          }
        })
    );
  const getListServices = () =>
    fncArrayGroupOption(
      getDataGreade()
        .services.filter((list) => list.active === "true")
        .sort(function (a, b) {
          if (a.order > b.order) {
            return 1;
          } else {
            return -1;
          }
        })
    );
  const router = useRouter();
  const setOptionMode = (mode) => {
    myConfiguration["option_mode"] = mode;
  };
  const getOptionMode = () => myConfiguration["option_mode"];
  const getOptionTabList = () => {
    let tabs = [];
    if (existsMakerOption()) tabs.push("maker_options");
    tabs.push("accessories", "services");
    return tabs;
  }

  const __setConfiguration = (key, value) => {
    myConfiguration[key] = value;
  };
  const __setConfigurationCheck = (key, value) => {
    let setParam = getMyCheck();
    setParam[key] = value;
    __setConfiguration("check", setParam);
  };
  const __clearConfiguration = () => {
    __setConfiguration("param", {});
    __setConfiguration("check", {});
  };
  const __setConfigurationParam = (key, value) => {
    // パラメータの設定がない場合は、以降の処理を行わない
    if (key === "") return;
    let setParam = getMyParam();
    setParam[key] = value;
    __setConfiguration("param", setParam);
  };

  const __setMmenuTitle = (main, sub) => {
    __setConfiguration("title", { main: main, sub: sub });
  };
  const __setMenuList = () => {
    let menu = menu_list;
    __setConfiguration("menu_list", menu);
    __setConfiguration("active_menu_index", 0);
    __setConfiguration("active_menu", menu[0]);
  };

  // カーコン選択時
  const selectConfiguration = (key, value, index) => {
    __changeSelect(key, value);
    __setConfigurationParam(key, value);
    // カーラインナップの時は、選択時に先頭メニューに遷移
    if (key == "code") {
      gotoMenu(0);
    }
  };

  // 選択変更
  const __changeSelect = (key, value) => {
    switch (key) {
      case "code":
        __changeCar(value);
        break;
      case "bodytype":
        __changeBodyType(value);
        break;
      case "engine_code":
        __changeEngine(value);
        break;
      case "grade_code":
        __changeGrade(value);
        break;
      case "color_code":
        __changeColor(value);
        break;
      default:
        __changeOption(key, value);
    }
  };

  // 車種変更
  const __changeCar = (value) => {
    __clearConfiguration();
    __setConfigurationCheck("code", value);
    const carInfo = getListCarLineup().find((list) => list.code === value);
    __setMmenuTitle(carInfo.name, carInfo.name_jp);
    __setConfiguration("carInfo", carInfo);
    let index = -1;

    const listGrade = getListGrade();
    index = listGrade.findIndex(({ checked }) => checked === "true");
    if (index < 0) {
      index = 0; //デフォルトがない場合は、先頭
    }
    __changeGrade(listGrade[index].code);

    __setMenuList();
  };

  // グレード変更
  const __changeGrade = (value) => {
    __setConfigurationCheck("grade_code", value);
    const gradeInfo = getListGrade().find((list) => list.code === value);
    __setConfiguration("gradeInfo", gradeInfo);
    // エンジンの情報もセット
    const engineInfo = gradeInfo.engine;
    __setConfigurationCheck("engine_code", engineInfo.code);
    __setConfiguration("engineInfo", engineInfo);

    let index = -1;

    const listColor = getListColor();
    index = listColor.findIndex(({ checked }) => checked === "true");
    if (index < 0) {
      index = 0; //デフォルトがない場合は、先頭
    }
    __changeColor(listColor[index].code);

    // オプションの最初をセット
    setOptionMode(getOptionTabList()[0]);

    // オプションメーカー
    const makerOptions_list = getListMakerOptions();
    makerOptions_list.forEach((item) => {
      index = item.list.findIndex(({ checked }) => checked === "true");
      if (index !== -1) {
        __changeOption(item.code, item.list[index].code);
      } else {
        __changeOption(item.code, "");
      }
    });
    // オプションアクセサリ
    const accessories_list = getListAccessories();
    accessories_list.forEach((item) => {
      index = item.list.findIndex(({ checked }) => checked === "true");
      if (index !== -1) {
        __changeOption(item.code, item.list[index].code);
      } else {
        __changeOption(item.code, "");
      }
    });
    // オプションサービス
    const services_list = getListServices();
    services_list.forEach((item) => {
      index = item.list.findIndex(({ checked }) => checked === "true");
      if (index !== -1) {
        __changeOption(item.code, item.list[index].code);
      } else {
        __changeOption(item.code, "");
      }
    });
  };

  // カラー変更
  const __changeColor = (value) => {
    __setConfigurationCheck("color_code", value);
    const colorInfo = getListColor().find((list) => list.code === value);
    __setConfiguration("colorInfo", colorInfo);
  };

  // オプション変更
  const __changeOption = (group, value) => {
    __setConfigurationCheck(group, value);
    let option_list = [];
    let index = -1;
    // メーカーオプション
    index = getListMakerOptions().findIndex(({ code }) => code === group);
    if (index > -1) {
      let item;
      let item_index = -1;
      option_list = getListMakerOptions()[index];
      item_index = option_list.list.findIndex(({ code }) => code === value);
      if (item_index > -1) {
        item = [option_list.list[item_index]];
      } else {
        item = [];
      }
      __setConfiguration(group + "Info", item);
    }
    // オプションアクセサリ
    index = getListAccessories().findIndex(({ code }) => code === group);
    if (index > -1) {
      let item;
      let item_index = -1;
      option_list = getListAccessories()[index];
      item_index = option_list.list.findIndex(({ code }) => code === value);
      if (item_index > -1) {
        item = [option_list.list[item_index]];
      } else {
        item = [];
      }
      __setConfiguration(group + "Info", item);
    }
    // オプションサービス
    index = getListServices().findIndex(({ code }) => code === group);
    if (index > -1) {
      let item;
      let item_index = -1;
      option_list = getListServices()[index];
      item_index = option_list.list.findIndex(({ code }) => code === value);
      if (item_index > -1) {
        item = [option_list.list[item_index]];
      } else {
        item = [];
      }
      __setConfiguration(group + "Info", item);
    }
  };

  const __getTotalPrice = () => {
    const select_grade = getDataGreade();
    const select_color = getDataColor();
    const select_makeroptions = getDataMakerOptions();
    const select_accessories = getDataAccessories();
    const select_services = getDataServices();
    let total_price = 0;
    total_price =
      total_price +
      priceRemoveComma(select_grade.price) +
      priceRemoveComma(select_color.price);
    for (let i = 0; i < select_services.length; i++) {
      for (let j = 0; j < select_services[i].list.length; j++) {
        total_price =
          total_price + priceRemoveComma(select_services[i].list[j].price);
      }
    }
    for (let i = 0; i < select_accessories.length; i++) {
      for (let j = 0; j < select_accessories[i].list.length; j++) {
        total_price =
          total_price + priceRemoveComma(select_accessories[i].list[j].price);
      }
    }
    for (let i = 0; i < select_makeroptions.length; i++) {
      for (let j = 0; j < select_makeroptions[i].list.length; j++) {
        total_price =
          total_price + priceRemoveComma(select_makeroptions[i].list[j].price);
      }
    }
    total_price = toLocaleString(total_price);
    return total_price;
  };

  const __getMySelect = () => {
    const active_menu = getMenuActive();
    return {
      key: active_menu.query,
      value: getMyCheck()[active_menu.query],
    };
  };

  // メニュー選択時
  const gotoMenu = (index) => {
    // 行き先
    __setMenu(index);
    let routeName = getMenuActive().name;
    let routeQuery = getMyCheck();
    router.push({ name: routeName, query: routeQuery });
  };

  const __setMenu = (index) => {
    __setConfiguration("active_menu_index", index);
    const menu_list = getMenuList()[index];
    __setConfiguration("active_menu", menu_list);

    let nextParamKey = menu_list.query;
    
    const tabList = getOptionTabList()
    const tabMode = getOptionMode()
    const tabCount = tabList.length
    if (nextParamKey == "option_code" && tabList[0]==tabMode) {
      nextParamKey = "accessories";
    } else if (nextParamKey == "option_code" && tabList[tabCount-1] == tabMode) {
      nextParamKey = "services";
    }

    let indexOption = getMenuList().findIndex(({ name }) => name === "option");
    if (index === indexOption) {
    } else if (index < indexOption) {
      setOptionMode(tabList[0]);
    } else {
      setOptionMode(tabList[tabCount-1]);
    }
    //__setConfigurationParam(nextParamKey, getMyCheck()[nextParamKey]);
  };

  // オプションの情報をグループ毎にします。
  const fncArrayGroupOption = (ary) => {
    const key = "group";
    let values = [];
    let lists = [];
    ary.filter((e, i, a) => {
      if (values.indexOf(e[key]) === -1) {
        values.push(e[key]);
        lists.push({
          code: e[key],
          name: a[i]["group"],
          order: a[i]["group_order"],
          list: a.filter((x) => x[key] === e[key]),
        });
        return e[key];
      }
    });
    lists.sort(function(a,b) {
      return a.order - b.order;
    });
    return lists;
  };
  const fncColorName = (name) => {
    return name.split("：");
  };
  const priceRemoveComma = (price) => {
    return parseInt(price.replace(/,/g, ""));
  };
  const toLocaleString = (num) => {
    return num.toLocaleString();
  };

  const getUrlFromPathName = () => {
    const route = useRoute();
    const menuIndex = getMenuList().findIndex(({ name }) => name === route.name);
    if (menuIndex >= 0) {
      __setMenu(menuIndex);
    }
  }

  // ----------------
  // 直リンク
  // ----------------
  if ("initialize" in myConfiguration) {
    delete myConfiguration["initialize"];
    setOptionMode(0);
    const route = useRoute();
    __clearConfiguration();
    // Homeは処理を行わない
    if (route.name !== "car_lineup") {
      let bError = false;
      let listMenu;
      let menuIndex;
      // 最初に車種情報をセット
      let key = "code";
      if ("code" in route.query) {
        try {
          __changeSelect(key, route.query[key]);
          listMenu = getMenuList();
          menuIndex = listMenu.findIndex(({ name }) => name === route.name);
          if (route.name === "engine") {
            menuIndex=0;
            router.push({ name: "grade", query: route.query});
          }
          if (menuIndex < 0) {
            bError = true;
          }
        } catch (error) {
          bError = true;
        }
      } else {
        bError = true;
      }

      if (bError) {
        alert(
          "指定された値が認識できませんでした。最初の入力からやり直しをお願いします。"
        );
        router.push({ name: "car_lineup" });
      } else {
        for (let i in listMenu) {
          // 次にメニュー順にセット
          const queryKey = listMenu[i].query;
          if (queryKey === "option_code") {
            const accessories_list = getListAccessories();
            accessories_list.forEach((item) => {
              const key = item.code;
              if (key in route.query) {
                __changeSelect(key, route.query[key]);
              } else {
                __changeSelect(key, "");
              }
            });

            const services_list = getListServices();
            services_list.forEach((item) => {
              const key = item.code;
              if (key in route.query) {
                __changeSelect(key, route.query[key]);
              } else {
                __changeSelect(key, "");
              }
            });
          } else {
            if (queryKey in route.query) {
              __changeSelect(queryKey, route.query[queryKey]);
            }
          }
        }
        __setMenu(menuIndex);
      }
    }
  }

  return {
    selectConfiguration,
    gotoMenu,

    getTitle,
    getQueryKey,
    getMenuList,
    getMenuActive,
    getMenuActiveIndex,

    getDataCar,
    getBodyType,
    getDataGreade,
    getDataEngine,
    getDataColor,
    getDataMakerOptions,
    getDataAccessories,
    getDataServices,
    getTotalPrice,

    getListCarLineup,
    getListGrade,
    getListColor,
    getListMakerOptions,
    getListAccessories,
    getListServices,
    existsMakerOption,

    getMyCheck,
    getMySelect,

    priceRemoveComma,
    toLocaleString,

    setOptionMode,
    getOptionMode,
    getOptionTabList,
    __setMenu,
    getUrlFromPathName
  };
}
